function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M21.1,14.5c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S24.9,14.5,21.1,14.5z M21.1,3.6c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4 S23.3,3.6,21.1,3.6z"
}))));

var SvgExperimentBubbleLarge = function SvgExperimentBubbleLarge(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/experiment-bubble-large.027eb616.svg";
export { SvgExperimentBubbleLarge as ReactComponent };